import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { TabView, TabPanel } from "primereact/tabview";
import { Button } from "primereact/button";

// ------------------ COMPONENTES DE BASE--------------------------
import { AuthContext } from "../../Base/Context/AuthContext/AuthContext";
import { getLabel } from "../../Base/Services/Language/LanguageService";
import Card from "../../Base/Components/Card/Card";
import { ConfigContext } from "../../Base/Context/ConfigContext/ConfigContext";
import { baseLang } from "../../Base/Lang/BaseLang";
import { setTitlePage } from "../../Base/Services/Config/ConfigService";
import Loader from "../../Base/Components/Loader/Loader";
import AgGrid from "../../Base/Components/Tables/AgGrid/AgGrid";

// ------------------- CONSULTAS A LA API---------------------------
import { getDensity, getDyeType, getFabricStyles } from "../../API/Desarrollo/DesarrolloRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import FabricStyleCRUD from "./CRUD/FabricStyleCRUD";
import DyeTypeCRUD from './CRUD/DyeTypeCRUD'
import DensityCRUD from './CRUD/DensityCRUD'

const ProcesosScreen = () => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const [activeIndex, setActiveIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [dialogFabric, setDialogFabric] = useState(false);
  const [dialogDyeT, setDialogDyeT] = useState(false);
  const [dialogDensity, setDialogDensity] = useState(false);
  const [selected, setSelected] = useState(null)


  const getInfo = async () => {
    setLoading(true);

    let result;
    switch (activeIndex) {
      case 0:
        result = await getFabricStyles();
        break;
      case 1:
        result = await getDyeType();
        break;
      case 2:
        result = await getDensity();
        break;
      default:
        console.warn('Invalid activeIndex');
        setLoading(false);
        return;
    }

    setData(result);
    setLoading(false);
  };

  const openDialog = () => {
    switch (activeIndex) {
      case 0:
        setDialogFabric(true);
        break;
      case 1:
        setDialogDyeT(true);
        break;
      case 2:
        setDialogDensity(true);
        break;
      default:
        console.warn('Invalid index for dialog');
        break;
    }
  };

  const columsFabricStyles = [
    {
      header: 'ID',
      headerEn: 'ID',
      field: 'IdFabricStyle',
      className: 'XXsmall',
      frozen: true,
      hidden: userAuth?.IdRol === 1
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        setDialogFabric(true)
        setSelected(data);
      },
      frozen: true,
      Format: "DateTime",
    },
    {
      field: "StatusName",
      header: "Estado",
      Sumary: 'count',
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        setDialogFabric(true)
        setSelected(data);
      },
      headerEn: "Status",
      className: "Xsmall",
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      Format: "Estado",
    },
    {
      header: 'Cant. Hilo',
      headerEn: 'Yarn Qty',
      field: 'YarnQuantity',
      onCellDoubleClicked: ({ data }) => {
        setDialogFabric(true)
        setSelected(data);
      },
      className: 'Xsmall',
      Format: 'Currency',
    },
    {
      header: 'Estilo de Tejido',
      headerEn: 'Fabric Style',
      field: 'FabricStyle',
      onCellDoubleClicked: ({ data }) => {
        setDialogFabric(true)
        setSelected(data);
      },
      className: 'large',
      flex: 1,
      minWidth:200,
    },
    {
      header: 'Descripción',
      headerEn: 'Description',
      field: 'Description',
      onCellDoubleClicked: ({ data }) => {
        setDialogFabric(true)
        setSelected(data);
      },
      className: 'large',
    },
    {
      header: 'Categoría de Estilo',
      headerEn: 'Style Category',
      field: 'StyleCategory',
      className: 'large',
      onCellDoubleClicked: ({ data }) => {
        setDialogFabric(true)
        setSelected(data);
      },
    },
    {
      header: 'Usuario Creación',
      headerEn: 'User Create',
      field: 'UserNameCreate',
      className: 'medium',
    },
    {
      header: 'Usuario Edición',
      headerEn: 'User Edit',
      field: 'UserNameEdit',
      className: 'medium',
    },
    {
      field: "DateUpdateStr",
      header: "Fecha Edición",
      headerEn: "Edit Date",
      className: "medium",
      Format: "DateTime",
    },
    {
      field: "IdFabricStyle",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            setDialogFabric(true)
            setSelected(rowData)
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },
  ]

  const columsDyeType = [
    {
      header: 'ID',
      headerEn: 'ID',
      field: 'IdDyeType',
      className: 'XXsmall',
      frozen: true,
      hidden: userAuth?.IdRol === 1
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "medium",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        setDialogDyeT(true)
        setSelected(data);
      },
      Format: "DateTime",
    },
    {
      field: "StatusName",
      header: "Estado",
      Sumary: 'count',
      frozen: true,
      headerEn: "Status",
      onCellDoubleClicked: ({ data }) => {
        setDialogDyeT(true)
        setSelected(data);
      },
      className: "Xsmall",
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      Format: "Estado",
    },
    {
      header: 'Tipo de Colorante',
      headerEn: 'Dye Type',
      field: 'DyeType',
      className: 'large',
      onCellDoubleClicked: ({ data }) => {
        setDialogDyeT(true)
        setSelected(data);
      },
      flex: 1,
      minWidth:200,
    },
    {
      header: 'Descripción',
      headerEn: 'Description',
      field: 'Description',
      className: 'Xlarge',
      onCellDoubleClicked: ({ data }) => {
        setDialogDyeT(true)
        setSelected(data);
      },
    },
    {
      header: 'Estilo de Categoría',
      headerEn: 'Style Category',
      field: 'StyleCategory',
      className: 'large',
      onCellDoubleClicked: ({ data }) => {
        setDialogDyeT(true)
        setSelected(data);
      },
    },
    {
      header: 'Usuario Creación',
      headerEn: 'User Create',
      field: 'UserNameCreate',
      className: 'medium',
    },
    {
      header: 'Usuario Edición',
      headerEn: 'User Edit',
      field: 'UserNameEdit',
      className: 'medium',
    },
    {
      field: "DateUpdateStr",
      header: "Fecha Edición",
      headerEn: "Edit Date",
      className: "medium",
      Format: "DateTime",
    },
    {
      field: "IdDyeType",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            setDialogDyeT(true)
            setSelected(rowData)
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },
  ]

  const columsDensity = [
    {
      header: 'ID',
      headerEn: 'ID',
      field: 'IdDensity',
      className: 'XXsmall',
      frozen: true,
      hidden: userAuth?.IdRol === 1
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        setDialogDensity(true)
        setSelected(data);
      },
      frozen: true,
      Format: "DateTime",
    },
    {
      field: "StatusName",
      Sumary: 'count',
      header: "Estado",
      frozen: true,
      headerEn: "Status",
      className: "Xsmall",
      onCellDoubleClicked: ({ data }) => {
        setDialogDensity(true)
        setSelected(data);
      },
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      Format: "Estado",
    },
    {
      header: 'Densidad',
      headerEn: 'Density',
      onCellDoubleClicked: ({ data }) => {
        setDialogDensity(true)
        setSelected(data);
      },
      field: 'Density',
      className: 'large',
      flex: 1,
      minWidth:200,
    },
    {
      header: 'Estilo de Categoría',
      headerEn: 'Style Category',
      field: 'StyleCategory',
      className: 'large',
      onCellDoubleClicked: ({ data }) => {
        setDialogDensity(true)
        setSelected(data);
      },
    },
    {
      header: 'Usuario Creación',
      headerEn: 'User Create',
      field: 'UserNameCreate',
      className: 'medium',
    },
    {
      header: 'Usuario Edición',
      headerEn: 'User Edit',
      field: 'UserNameEdit',
      className: 'medium',
    },
    {
      field: "DateUpdateStr",
      header: "Fecha Edición",
      headerEn: "Edit Date",
      className: "medium",
      Format: "DateTime",
    },
    {
      field: "IdDensity",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            setDialogDensity(true)
            setSelected(rowData)
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },
  ]

  //----TABLAS-----
  const tableFabricStyles = {
    Columns: columsFabricStyles,
    Data: data,
  }

  const tableDyeType = {
    Columns: columsDyeType,
    Data: data,
  }
  
  const tableDensity = {
    Columns: columsDensity,
    Data: data,
  }
  

  useEffect(() => {
    getInfo();
    setTitlePage(getLabel(baseLang, "Procesos", config.language));
  }, [activeIndex]);

  return (
    <div>
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones flex-wrap  flex-wrap">
            <h2>{getLabel(baseLang, "Procesos", config.language)}</h2>
            <Button
              icon="pi pi-refresh"
              tooltip="Buscar"
              onClick={() => getInfo()}
            />


            <Button
              icon="pi pi-plus"
              tooltip="Nuevo"
              onClick={(e) => openDialog()}
            />
          </div>
        }
        contenido={
          <div className="pt-4">
            <Loader loading={loading} />

            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >

              <TabPanel header={getLabel(baseLang, "fabricStyle", config.language)}>
                <div style={{ height: '83vh' }}>
                  <AgGrid table={tableFabricStyles} />
                </div>
              </TabPanel>

              <TabPanel header={getLabel(baseLang, "dyeType", config.language)}>
                <div style={{ height: '83vh' }}>
                  <AgGrid table={tableDyeType} />
                </div>
              </TabPanel>

              <TabPanel header={getLabel(baseLang, "density", config.language)}>
                <div style={{ height: '83vh' }}>
                  <AgGrid table={tableDensity} />
                </div>
              </TabPanel>

            </TabView>
          </div>
        }
      />

      {dialogFabric && (
        <FabricStyleCRUD
          dialog={dialogFabric}
          setDialog={setDialogFabric}
          selected={selected}
          setSelected={setSelected}
          modo={selected ? 'Editar' : 'Crear'}
          getInfo={getInfo}
        />
      )}

      {dialogDyeT && (
        <DyeTypeCRUD
          dialog={dialogDyeT}
          setDialog={setDialogDyeT}
          selected={selected}
          setSelected={setSelected}
          modo={selected ? 'Editar' : 'Crear'}
          getInfo={getInfo}
        />
      )}

      {dialogDensity && (
        <DensityCRUD
          dialog={dialogDensity}
          setDialog={setDialogDensity}
          selected={selected}
          setSelected={setSelected}
          modo={selected ? 'Editar' : 'Crear'}
          getInfo={getInfo}
        />
      )}
    </div>
  );
};

export default ProcesosScreen;
